import * as React from "react";
import { useLocalization } from "@shared-ui/localization-context";

import { UitkCardAlohaContentSection, UitkCardAlohaLink } from "uitk-react-cards";
import { UitkLayoutFlex, UitkLayoutFlexItem } from "uitk-react-layout-flex";
import { UitkLayoutGridItem } from "uitk-react-layout-grid";
import { UitkSpacing } from "uitk-react-spacing";

import CardTitle from "../shared/CardTitle";
import HotelRating from "../shared/HotelRating";
import AddressAndNeighborhood from "../shared/AddressAndNeighborhood";
import PricesAndDate from "../shared/PricesAndDate";
import FlightInfo from "../shared/FlightInfo";
import DescriptionAndGuestReviewSectionWrapper from "../shared/DescriptionAndGuestReviewSectionWrapper";

import { TrackedLink } from "components/utility/analytics/TrackedLink";

import { PackageCardProps } from "components/flexComponents/Packages/typings";

export const DefaultCardContents = ({ packageItem, index, language, overImage, grid }: PackageCardProps) => {
  const { formatText } = useLocalization();

  const content = (
    <UitkCardAlohaContentSection padded={false}>
      <UitkCardAlohaContentSection>
        <UitkLayoutFlex justifyContent="space-between" className="truncate">
          <UitkLayoutFlexItem className="truncate">
            <div>
              <CardTitle cardTitle={packageItem.hotelName} />
              <HotelRating rating={packageItem.hotelStarRating} isText={false} />
              <AddressAndNeighborhood packageItem={packageItem} />
            </div>
          </UitkLayoutFlexItem>
          <UitkLayoutFlexItem>
            <div>
              <PricesAndDate
                packageItem={packageItem}
                renderSavingBadge={true}
                renderDates={true}
                overImage={overImage}
              />
            </div>
          </UitkLayoutFlexItem>
        </UitkLayoutFlex>
        <UitkSpacing margin={{ blockstart: "two" }}>
          <UitkLayoutFlex direction="column">
            <UitkLayoutFlexItem className="truncate">
              <FlightInfo packageItem={packageItem} />
            </UitkLayoutFlexItem>
          </UitkLayoutFlex>
        </UitkSpacing>
      </UitkCardAlohaContentSection>
      <DescriptionAndGuestReviewSectionWrapper
        packageItem={packageItem}
        language={language}
        renderReviewRating={true}
      />
      <UitkCardAlohaLink>
        <TrackedLink
          className="uitk-card-link"
          rfrr={`card-${index}`}
          href={packageItem.shopUrl}
          aria-label={formatText("package.card.ariaLabel.fh")}
          moduleName="packages"
        />
      </UitkCardAlohaLink>
    </UitkCardAlohaContentSection>
  );
  if (grid) {
    return <UitkLayoutGridItem colSpan={2}>{content}</UitkLayoutGridItem>;
  }

  return content;
};
